const NoDataMessage = ({ style, children }) => (
  <div className="no-data" style={style}>
    {children}
  </div>
);

export default NoDataMessage;
